import { RouteNames } from '@/router/routeNames';
import type { NavigationGuardWithThis } from 'vue-router';
// Initialize to false for the first navigation, we don't want to redirect to dashboard on first load, only on reloads
let hasEvaluatedInitialNavigation = false;

const isReloadNavigation = () => {
  // Browser Performance Navigation API to see if reload was a browser refresh or a normal navigation
  // For normal page load you usually get one item eg entries[0] with type properties that can have these values: navigate, reload, back_forward, prerender
  // If the reload value is there for type this tells us that it's a user manually refreshing the page.
  const entries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  if (entries.length > 0) {
    return entries[0].type === 'reload';
  }
  // This is to support legacy browser which checks the type under the performance.navigation.type it returns a number
  // 0 for normal navigation, 1 for reload, 2 for back or forward. We are checking for reload or 1
  const legacyPerformance = performance as Performance & {
    navigation?: { type?: number };
  };
  const legacyNavigationType =
    'navigation' in legacyPerformance
      ? (legacyPerformance.navigation as { type?: number } | undefined)?.type
      : undefined;
  return legacyNavigationType === 1;
};

export const reloadToDashboardGuard: NavigationGuardWithThis<undefined> = (to) => {
  // This allows navigation, happens for the very first navigation to the app, we don't want to redirect to dashboard on first load, only on reloads
  if (hasEvaluatedInitialNavigation) {
    return true;
  }
  // This is the initial navigation, mark it as evaluated
  hasEvaluatedInitialNavigation = true;

  // If this is not a reload navigation, allow the navigation to proceed
  if (!isReloadNavigation()) {
    return true;
  }
  // If this is a reload navigation and the user is trying to navigate to the dashboard, allow it
  if (to.name === RouteNames.DASHBOARD) {
    return true;
  }
  // If this is a reload navigation and the user is trying to navigate to any other route, redirect to the dashboard
  return {
    name: RouteNames.DASHBOARD,
    replace: true,
  };
};
